import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { makeApiCall } from "src/api/apiRequests";
import { useUserdata } from "src/store/UserData";
import SimpleBar from "simplebar-react";
import API_HEADERS from "src/api/apiConfig";
import API_PATHS from "src/api/apiPaths";
import FLASH_MESSAGES from "src/helpers/FlashMessages";

interface GroupParticipantsProps {
  onShowModal: boolean;
  setShowModal: (visible: boolean) => void;
}

const GroupParticipants: React.FC<GroupParticipantsProps> = ({
  onShowModal,
  setShowModal,
}) => {
 const ref = useRef<null>(null);
const userData = useUserdata((state: any) => state.userData);
const { threadId } = useParams();
const {t}=useTranslation()
const [partecipants, setPartecipants] = useState<any[]>([]);


const onClose = () => setShowModal(false);


const getMessagesOfThread = async () => {
    
     try {
       const response: any = await makeApiCall<ResponseType>(
         API_PATHS.threadMessages(Number(threadId)),
         "GET",
         API_HEADERS.authenticated
       );
     
       setPartecipants(response.participants);
     } catch (error: any) {
          FLASH_MESSAGES.errorMsg(error.response.data.error);
     }
   };
   useEffect(()=>{
    getMessagesOfThread()
   },[])
  return (
    <>
      <Modal isOpen={onShowModal} toggle={() => onClose()} size="md" centered>
        <ModalHeader>{t("particpiant_user")}</ModalHeader>
        <ModalBody>
          <div className="participants">
            <SimpleBar ref={ref} style={{ height: "200px" }}>
              {partecipants
                .filter((item: any) => item.user_id !== userData.id)

                .map((item: any) => (
                  <>
                    <li className="text mt-3" key={item.id} >
                      {item.user ? (
                        <>
                          {item.user.first_name} {item.user.last_name}<br/>
                          <a href={`mailto: ${item.user.email}`} className="ms-4">
                            {item.user.email}
                          </a>
                          
                        </>
                      ) : (
                        "Unknown User"
                      )}
                    </li>
                  </>
                ))}
            </SimpleBar>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="button-white"
            type="button"
            onClick={() => onClose()}
          >
            {t("group_participants_close_button")}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default GroupParticipants;
